// extracted by mini-css-extract-plugin
export var card = "CardHeading-module--card--eb3dc";
export var container = "CardHeading-module--container--38ef3";
export var info = "CardHeading-module--info--0f6a4";
export var rating = "CardHeading-module--rating--f6bd7";